var _defs, _circle, _g, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "sun",
    cx: "40%",
    cy: "30%",
    r: "80%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff0b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#ffc23d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff7a00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "halo",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#ffcf4d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffcf4d",
    stopOpacity: 0.35
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 150,
    fill: "url(#halo)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffd06b",
    strokeWidth: 7,
    strokeLinecap: "round",
    opacity: 0.75,
    transform: "rotate(15 100 100)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 10,
    x2: 100,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 166,
    x2: 100,
    y2: 190
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 100,
    x2: 34,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166,
    y1: 100,
    x2: 190,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 36,
    x2: 53,
    y2: 53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147,
    y1: 147,
    x2: 164,
    y2: 164
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164,
    y1: 36,
    x2: 147,
    y2: 53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 147,
    x2: 36,
    y2: 164
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 66,
    fill: "url(#sun)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.93ed16ba3095c6ea40b285519510a9be.svg";
export { ForwardRef as ReactComponent };